<template>
  <v-container>
    <v-row>
      <v-col>
       <div class="box-header">
          <v-btn class="secondary" @click="create()" v-if="buttonShow('create', currentUserRole)">
            Create new
          </v-btn>
        </div>
        <div class="box-body">
          <v-card>
          <v-card-text>
            <v-layout wrap mb-2 style="justify-content:right">
              <v-flex xs12 md2 pr-3>
                <v-autocomplete
                  v-model="filters.role"
                  item-value="id" 
                  item-text="name"
                  :items="userRoleOptions"
                  label="Role Filter"
                  hide-details
                  outlined
                  dense
                  auto-select-first
                  @change="paginate(1)"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  class="pt-0"
                  v-model="filters.keyword"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  @keyup.enter="paginate(1)"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-data-table
              :headers="fields"
              :items="items"
              :options.sync="pagination"
              :server-items-length="totalRows"
            >
            <template v-slot:body="{items}">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{item.firstName}}</td>
                  <td>{{item.lastName}}</td>
                  <td>{{item.email}}</td>
                  <td>{{roleDisplay(item.role)}}</td>
                  <td>
                    <v-btn
                    color="red" 
                    class="ims-action"
                    small v-if="buttonShow('delete', item.role)"
                    @click.stop="deleteUser(item)">
                      <v-icon
                        v-on="on"
                        style="color:#fff"
                        small
                      >mdi-delete</v-icon>
                    </v-btn>

                    <!-- Edit button -->
                    <!-- color="warning" -->
                    <v-btn
                    small
                    class="ims-action primary"
                    data-toggle="modal"
                    :data-target="editModalIdDisplay"
                    v-if="buttonShow('update', item.role)"
                    @click="getUserDataToEdit(item.id)">
                    <!-- style="color:#fff" -->
                      <v-icon
                        v-on="on"
                        small
                      >mdi-account-edit</v-icon>   
                    </v-btn>

                    <!-- View button -->
                    <v-btn
                    small
                    color="info"
                    class="ims-action"
                    data-toggle="modal"
                    :data-target="viewModalIdDisplay"
                    v-if="buttonShow('view', item.role)"
                    @click="getUserDataToView(item.id)">
                      <v-icon
                        v-on="on"
                        style="color:#fff"
                        small
                      >mdi-eye</v-icon>   
                    </v-btn>

                    <!-- Assign client button -->
                    <!-- <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" :data-target="assignUserToClientModalIdDisplay" v-if="buttonShow('assignClient', item.role)" @click="getUserDataToView(item.id)">
                      <i class="fa fa-user-plus"></i>
                    </button> -->

                    <!-- Confirm User(Influencer) button -->
                    <v-btn
                    small
                    color="info"
                    class="ims-action"
                    data-toggle="modal"
                    :data-target="confirmUserModalIdDisplay"
                    v-if="buttonShow('confirmUser', item.role)"
                    @click="getUserDataToEdit(item.id)">
                      <v-icon
                        v-on="on"
                        style="color:#fff"
                        small
                      >mdi-check</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
            </v-data-table>
          </v-card-text>
          <!-- <b-pagination class="pb-3 mt-0" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" size="sm" align="center" /> -->
        </v-card>
        </div>
      </v-col>
    </v-row>
    <!-- CreateUser modal -->
    <create-user-modal v-model="createUserModalDialog" @createUser="createUser" />

    <!-- EditUser modal -->
    <edit-user-modal :modalId="editModalId" :userData="editUserData" @editUser="editUser" />

    <!-- ViewUser modal -->
    <view-user-modal :modalId="viewModalId" :userData="viewUserData" />

    <!-- AssignUserToClient modal -->
    <assign-user-to-client-modal :modalId="assignUserToClientModalId" :userData="viewUserData" />

    <!-- ConfirmUser(Influencer) modal -->
    <confirm-user-modal :modalId="confirmUserModalId" :userData="editUserData" @editUser="editUser" />    
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
import config from '@/config'
import userAPIs from './userAPIs'
import CreateUserModal from './CreateUserModal'
import EditUserModal from './EditUserModal'
import ViewUserModal from './ViewUserModal'
import AssignUserToClientModal from './AssignUserToClientModal'
import ConfirmUserModal from './ConfirmUserModal'
import clientAPIs from '../Client/clientAPIs';

export default {
  name: 'User',
  components: {
    CreateUserModal,
    EditUserModal,
    ViewUserModal,
    AssignUserToClientModal,
    ConfirmUserModal
  },
  data() {
    return {
      createUserModalDialog: false,
      editModalId: 'edit_user_modal',
      viewModalId: 'view_user_modal',
      assignUserToClientModalId: 'assign_user_to_client_modal',
      confirmUserModalId: 'confirm_user_modal',
      editUserData: null,
      viewUserData: null,
      sortDesc: false,
      fields: [
        {
          text: 'First Name',
          value: 'firstName'
          // sortable: true
        },
        {
          text: 'Last Name',
          value: 'lastName'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          // A regular column with custom formatter
          text: 'Role',
          value: 'role'
        },
        {
          text: 'Actions',
          value: 'actions'
        }
      ],
      items: [],
      // pagination: {
      //   rowsPerPage: 10
      // },
      pagination: {
        // v-data-table pagination
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [],
        itemsPerPage: 15
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filters: {
        keyword: '',
        role: ''
      }
    }
  },
  computed: {
    ...mapState({
      campaignsCount: state => state.campaign.campaignsCount
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    },
    editModalIdDisplay: function() {
      return '#' + this.editModalId
    },
    viewModalIdDisplay: function() {
      return '#' + this.viewModalId
    },
    assignUserToClientModalIdDisplay: function() {
      return '#' + this.assignUserToClientModalId
    },
    confirmUserModalIdDisplay: function() {
      return '#' + this.confirmUserModalId
    },
    userRoleOptions: function() {
      let userTypeTemp = []
      Object.keys(config['userRolesDetails']).forEach(function(element) {
        userTypeTemp.push({
          id: element,
          name: config['userRolesDetails'][element]['display']
        })
      })
      userTypeTemp.unshift({
        id: '',
        name: '-- All --'
      })
      return userTypeTemp
    }
  },
  watch: {
    currentPage() {
      this.paginate(this.currentPage)
    },
    pagination(newVal) {
      this.paginate(newVal.page);
    }
  },
  methods: {
    create() {
      this.createUserModalDialog = true
    },
    roleDisplay: value => {
      return value === undefined ? '-' : config['userRolesDetails'][value]['display']
    },
    buttonShow(type, role) {
      const roleAllow = config['userPermissions']['user'][type][this.currentUserRole]
      return roleAllow ? roleAllow.includes(role) : false
    },
    // buttonAssignShow(role) {
    //   return role === config.userRoles.AD_STRATEGIST
    // },
    updateItems(response) {
      this.items = response.users
      this.totalRows = response.totalUsers
    },
    paginate(page = 1) {
      this.currentPage = page
      userAPIs
        .paginate(page, this.perPage, this.filters.keyword, this.filters.role)
        .then(response => {
          this.updateItems(response)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    createUser(userData) {
      this.paginate(1)
    },
    async deleteUser(user) {
      let counts = {}
      let userID = user.id
      let userRole = user.role
      this.isLoading = false
      let htmlTxt = 'Are you sure you want to delete this influencer? This action cannot be undone.<br>';
      if (userRole === config.userRoles.AD_STRATEGIST ||
      userRole === config.userRoles.ACCOUNT_MANAGER ||
      userRole === config.userRoles.COMPANY_ADMIN_LOW) {
        await this.$store.dispatch('campaign/getCampaignsByAssignedID', {
          userID
        })
        let resp = await clientAPIs.getClientsByAssignedID({userID})
        if (resp) {
          counts.clients = resp.count
        }
        counts.campaigns = this.campaignsCount
        htmlTxt += `Total Clients: ${counts.clients}<br>`
        htmlTxt += `Total Campaigns: ${counts.campaigns}`
      }
      this.$swal({
        title: 'Deleting',
        html: htmlTxt,
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return userAPIs
            .deleteUser(userID)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.items = this.items.filter(user => user.id !== userID)

          // Show success message
          this.$swal({
            title: 'Deleted',
            text: 'The user has been deleted successfully',
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    getUserDataToEdit(userID) {
      userAPIs
        .getUser(userID)
        .then(response => {
          this.editUserData = response
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    getUserDataToView(userID) {
      userAPIs
        .getUser(userID)
        .then(response => {
          this.viewUserData = response
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    editUser(userData) {
      // Update the edited content to user
      var selectedIndex = -1

      this.items.forEach(function(user, index) {
        if (user.id === userData.id) {
          selectedIndex = index
          return
        }
      })

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, userData)
      }

      // Do anything like highlighting the edited item
    }
  },
  created() {
    this.paginate(this.currentPage)
  }
}
</script>
<style scoped>
  .ims-action {
    height: 35px!important;
  }
</style>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?6144262f